
import { Component, namespace, Prop, State, Vue } from 'bits/vue'
import { SearchFilters } from 'bits/web_search'
import ActionableChiclet from 'library/v4/components/actionable-chiclet.vue'
import { ContentPickerSource } from 'vuexstore/modules/content_picker'

@Component({ components: { ActionableChiclet } })
export default class ContentSourceMenuList extends Vue {
  Source = ContentPickerSource
  SearchFilters = SearchFilters
  @State((state) => state.isTablet) isDeviceTablet!: boolean
  @State((state) => state.isPhone) isDevicePhone!: boolean
  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean
  @Prop() clipboardText!: string
  @Prop() xClipboardButton!: boolean
  @Prop() audioSupport!: boolean
  @Prop() videoSupport!: boolean
  @Prop() screenshareSupport!: boolean
  @Prop({ default: false }) disabled!: boolean

  @namespace('contentPicker').Getter xAiImageSeach!: boolean
  @namespace('contentPicker').Action endLinkInputMode!: () => void

  select(source: ContentPickerSource): void {
    this.endLinkInputMode()
    this.$emit('select', source)
  }

  focusSearchBar(filter: SearchFilters): void {
    this.endLinkInputMode()
    this.$emit('focus-search-bar', filter)
  }

  pasteText(): void {
    this.$emit('paste-text')
  }

  triggerLinkInput(): void {
    this.$emit('trigger-link-input')
  }

  triggerAiImageSearch(): void {
    this.$emit('trigger-ai-image-search')
  }
}
